module.exports = __webpack_public_path__ + "images/liinilaevad/routes/GDN-NYN-GDN@2x.png";